import type { RouteRecordRaw, Router } from 'vue-router'

const PersonnelEmbezzlementRoutes: RouteRecordRaw = {
  path: '/claim/personnelEmbezzlement',
  name: 'PersonnelEmbezzlementModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'PersonnelEmbezzlementMainRoute',
      component: () => import('./views/PersonnelEmbezzlementView.vue'),
      meta: {
        title: 'personnelEmbezzlement.personnelEmbezzlementClaims',
      },
    },
    {
      path: 'create',
      name: 'PersonnelEmbezzlementCreateRoute',
      component: () => import('./views/PersonnelEmbezzlementUpsertView.vue'),
      meta: {
        title: 'personnelEmbezzlement.createPersonnelEmbezzlement',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:personnelEmbezzlementId',
      name: 'PersonnelEmbezzlementEditRoute',
      component: () => import('./views/PersonnelEmbezzlementUpsertView.vue'),
      meta: {
        title: 'personnelEmbezzlement.editPersonnelEmbezzlement',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:personnelEmbezzlementId',
      name: 'ViewPersonnelEmbezzlementRoute',
      component: () => import('./views/SinglePersonnelEmbezzlementView.vue'),
      meta: {
        title: 'personnelEmbezzlement.ViewPersonnelEmbezzlement',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(PersonnelEmbezzlementRoutes)
}
